import React, {Component}               from "react";
import {Text, TouchableOpacity, View}   from "react-native";
import {connect}                        from "react-redux";
import * as Actions                     from "../../constants/Actions";
import * as Screens                     from "../../constants/Screens";
import styles                           from "../../styles/Styles";

class ScreenCredits extends Component {
    render() {
        return (
            <View style={styles.background}>
                <TouchableOpacity onPress={this.props.changeScreen} style={styles.backgroundCredits}>
                    <View style={styles.viewCreditsLayout}>
                        <Text style={styles.textTitleCredits}>CREDITS</Text>
                        
                        <View style={styles.viewCreditsRow}>
                            <View style={styles.viewCreditDisplay}>
                                <Text style={styles.textWhite}>Development Team</Text>
                                <Text> </Text>
                                <Text style={styles.textWhite}>Richard McKenna</Text>
                                <Text style={styles.textWhite}>Andrew Marrell</Text>
                                <Text style={styles.textWhite}>Conor McDermott</Text>
                            </View>
                        </View>
                        
                        <View style={styles.viewCreditsRow}>
                            <View style={styles.viewCreditDisplay}>
                                <Text style={styles.textWhite}>Art</Text>
                                <Text> </Text>
                                <Text style={styles.textWhite}>Robert Giordano</Text>
                            </View>
                            <View style={styles.viewCreditDisplay}>
                                <Text style={styles.textWhite}>Sound Effects Courtesy of</Text>
                                <Text> </Text>
                                <Text style={styles.textWhite}>freesound.org</Text>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>
            </View>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen: () => { dispatch({type: Actions.CHANGE_SCREEN, screen: Screens.TITLE}) }
    };
}

export default connect(null, mapDispatchToProps)(ScreenCredits);